export default __webpack_public_path__ + "bae44ef27b4b95426bfc6fa6d5c234cf.png";